export default __webpack_public_path__ + "static/media/BranchManagement.32b15432.svg";